import React from 'react'
import ProductDetail from '../components/ProductDetail';
import ProductBanner from '../components/ProductDetailBanner';
import RelatedProducts from '../components/RelatedProduct';
import { useParams } from 'react-router-dom';
const ProductDetailPage = () => {
  const { productId } = useParams();
  return (
    <div>
        <ProductBanner />
      <ProductDetail />
      <RelatedProducts currentProductId={productId} />
    </div>
  )
}

export default ProductDetailPage
